import { RoleTypeEnum } from '../role-type'

export const UserRoleMapper: { [id: number]: string } = {
	[RoleTypeEnum.Doctor]: 'D',
	[RoleTypeEnum.Lab]: 'L',
	[RoleTypeEnum.Technician]: 'T'
}
